import type { ToastPosition } from '@hub/hooks/useToasts';
import { ToastType, useToasts } from '@hub/hooks/useToasts';
import * as Sentry from '@sentry/nextjs';

export const useCopyLinkToClipboard = (toastContent: string) => {
  const { addToast } = useToasts();

  const copyLinkToClipboard = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      addToast({
        content: toastContent,
        type: ToastType.SUCCESS,
        position: 'top-72 right-0 items-center max-w-[45rem]' as ToastPosition,
      });
    } catch (error) {
      Sentry.captureException(new Error(`Could not copy to clipboard - ${error as string}`));
    }
  };

  return { copyLinkToClipboard };
};
